import { anonymousHttpClient, httpClient } from "../../../lib/http/axios";
import { mapItineraryTable, type ItineraryTableResponseRaw } from "../api/adapters";

type TableResponse = ItineraryTableResponseRaw;

/** 每次进入独立表格页面读取数据库版本，不消费编辑器缓存。 */
export async function getItineraryTable(itineraryId: string, signal?: AbortSignal) {
  const response = await httpClient.get<TableResponse>(`/itineraries/${encodeURIComponent(itineraryId)}/table`, { signal });
  return mapItineraryTable(response.data.data);
}

/** 通过原分享授权会话读取表格白名单数据。 */
export async function getPublicItineraryTable(shareId: string) {
  const response = await anonymousHttpClient.get<TableResponse>(`/itineraries/public/${encodeURIComponent(shareId)}/table`, { withCredentials: true });
  return mapItineraryTable(response.data.data);
}
